import React from "react";
import { X, Star, TrendingUp } from "lucide-react";
import { JobPosting } from "../../types/job";
import JobCard from "./JobCard";

interface JobRecommendationsProps {
  jobs: JobPosting[];
  onBookmark: (jobId: string) => void;
  onClose: () => void;
}

const JobRecommendations: React.FC<JobRecommendationsProps> = ({
  jobs,
  onBookmark,
  onClose,
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-blue-100 rounded-lg">
            <TrendingUp className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              맞춤 추천 채용공고
            </h3>
            <p className="text-sm text-gray-600">
              당신의 프로필에 맞는 채용공고를 추천해드립니다
            </p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-white/50 rounded-full transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {jobs.slice(0, 4).map((job) => (
          <div key={job.id} className="relative">
            <div className="absolute -top-2 -right-2 z-10">
              <div className="flex items-center gap-1 px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                <Star className="w-3 h-3 fill-current" />
                <span>추천</span>
              </div>
            </div>
            <JobCard job={job} onBookmark={onBookmark} />
          </div>
        ))}
      </div>

      <div className="mt-4 text-center">
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
          더 많은 추천 채용공고 보기
        </button>
      </div>
    </div>
  );
};

export default JobRecommendations;
